export { default as GiftFlag } from './GiftFlag';
